import { Button, ButtonProps, LinkProps } from '@chakra-ui/react';
import IconArrowBack from 'assets/icons/icon-arrow-back.svg?react';
import React from 'react';

type Props = ButtonProps & LinkProps & {
  title?: string,
  to?: string
};

const ButtonBack = React.forwardRef(({ title, ...props }: Props, ref) => {
  return (
    <Button
      ref={ref}
      leftIcon={<IconArrowBack />}
      {...props}
    >
      { title ? title : 'Voltar' }
    </Button>
  )
});

export default ButtonBack;